import * as React from 'react';
import { IIcon } from '../../interfaces/IIcon';
import { Icon } from '../Icon';

const style: React.CSSProperties = {
    fill: 'none',
};
export function PeopleIcon(props: IIcon) {
    return (
        <Icon
            width={props.width}
            height={props.height}
            viewBox={props.viewBox}
            style={props.style}
            className={props.className}
        >
            <g>
                <g>
                    <path
                        style={style}
                        d="M399.8,231.7c25.5,0,46.3-20.8,46.3-46.3s-20.8-46.3-46.3-46.3c-25.5,0-46.3,20.8-46.3,46.3S374.3,231.7,399.8,231.7z"
                    />
                    <path d="M399.8,249.5c35.3,0,64-28.7,64-64s-28.7-64-64-64s-64,28.7-64,64S364.6,249.5,399.8,249.5z M399.8,139.2c25.5,0,46.3,20.8,46.3,46.3s-20.8,46.3-46.3,46.3c-25.5,0-46.3-20.8-46.3-46.3S374.3,139.2,399.8,139.2z" />
                    <path d="M478.4,286.6c-17.3-17.6-40.4-27.3-64.8-27.3H386c-24.4,0-47.4,9.7-64.8,27.3c-1.8,1.9-3.6,3.8-5.2,5.8c5.4,2.6,10.5,5.7,15.4,9.2c1.5-1.7,3.1-3.3,4.7-4.8C349.8,284,367.5,277,386,277h27.6c18.5,0,36.3,7,49.9,19.7c13.1,12.2,21.3,28.5,23.4,46.1H367.4c3,5.7,5.4,11.7,7.4,17.8h121.5c4.9,0,8.9-4,8.9-8.9C505.2,327.3,495.7,304.1,478.4,286.6z" />
                </g>
                <g>
                    <path d="M253.8,293.5c35.3,0,64-28.7,64-64s-28.7-64-64-64s-64,28.7-64,64S218.5,293.5,253.8,293.5z M207.5,229.5c0-25.5,20.8-46.3,46.3-46.3c25.5,0,46.3,20.8,46.3,46.3c0,25.5-20.8,46.3-46.3,46.3C228.3,275.8,207.5,255,207.5,229.5z" />
                    <path d="M332.4,330.7C315,313,292,303.3,267.5,303.3h-27.6c-24.4,0-47.4,9.7-64.8,27.3c-17.3,17.5-26.8,40.7-26.8,65.2c0,4.9,4,8.9,8.9,8.9h193c4.9,0,8.9-4,8.9-8.9C359.1,371.4,349.7,348.2,332.4,330.7z M340.9,386.9H166.7c2.1-17.7,10.3-34,23.4-46.1c13.7-12.7,31.4-19.7,49.9-19.7h27.6c18.5,0,36.3,7,49.9,19.7C330.6,353,338.8,369.3,340.9,386.9z" />
                </g>
                <g>
                    <path
                        style={style}
                        d="M107.8,232.3c25.5,0,46.3-20.8,46.3-46.3s-20.8-46.3-46.3-46.3c-25.5,0-46.3,20.8-46.3,46.3S82.3,232.3,107.8,232.3z"
                    />
                    <path d="M107.8,250c35.3,0,64-28.7,64-64s-28.7-64-64-64c-35.3,0-64,28.7-64,64S72.5,250,107.8,250z M107.8,139.7c25.5,0,46.3,20.8,46.3,46.3s-20.8,46.3-46.3,46.3c-25.5,0-46.3-20.8-46.3-46.3S82.3,139.7,107.8,139.7z" />
                    <path d="M20.7,343.4c2.1-17.7,10.3-34,23.4-46.1c13.7-12.7,31.4-19.7,49.9-19.7h27.6c18.5,0,36.3,7,49.9,19.7c1.1,1.1,2.2,2.2,3.3,3.3c5-3.4,10.2-6.4,15.7-9c-1.3-1.5-2.7-3-4.1-4.4c-17.3-17.6-40.4-27.3-64.8-27.3H94c-24.4,0-47.4,9.7-64.8,27.3c-17.3,17.5-26.8,40.7-26.8,65.2c0,4.9,4,8.9,8.9,8.9h118.5c1.9-6.1,4.4-12.1,7.3-17.8H20.7z" />
                </g>
            </g>
        </Icon>
    );
}
